// Auto-generated address book for chain 31337 (scripts/deployLocal.cjs writes this per deploy).
// One book per chain; src/lib/contracts.js selects among them by VITE_TARGET_CHAIN, so mainnet,
// Sepolia and local hardhat no longer overwrite one another in a single shared file.
export const IS_DEPLOYED = true;
export const CHAIN_ID = 31337;
export const ADDRESSES = {
  HORIZON_TOKEN:      "0x1e550FABd89c3a27dd8451D67de2b07683345047",
  // Testnet-only public HORIZON faucet (zero address on mainnet / any non-DEPLOY_FAUCET run). The
  // dapp's "Get test tokens" panel shows a drip button only when this is set.
  HORIZON_FAUCET:     "0x0000000000000000000000000000000000000000",
  HORIZON_EMISSIONS:  "0x923602FD33e8323F50d4EDE0A4459cc453d64c82",
  // The HORIZON/USDx Uniswap V3 pool. Recorded directly rather than resolved through whatever
  // happens to hold liquidity in it, because it is this app's ONLY HORIZON/USD price signal
  // (useHorizonPriceUsd) and that signal must outlive any one consumer - it was previously read
  // off the LP farm's farm-0 struct, which tied the whole app's USD pricing to a contract now
  // being retired. The pool itself is permanent; the things holding positions in it are not.
  HORIZON_WETH_POOL:  "0x7E073CcCb2A9f3173D241a39f6Eb70fAbFEd9B19",
  USDX:            "0x0165F534491a5A96d3BfD88D36191cB6839997cB",
  hUSD:            "0x0000000000000000000000000000000000000000",
  WETH:            "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
  SWAP_ROUTER:     "0xE592427A0AEce92De3Edee1F18E0157C05861564",
  NPM:             "0xC36442b4a4522E871399CD717aBDD847Ab11FE88",
  LENDING_POOL:    "0x1e8dBcC112122bdC07FCC5A19e502e3Fb380bec5",
  S_TOKEN_USDX:    "0x0000000000000000000000000000000000000000",
  S_TOKEN_hUSD:    "0x0000000000000000000000000000000000000000",
  SAVINGS_hUSD:    "0x0000000000000000000000000000000000000000",
  S_TOKEN_WETH:    "0xBDe204DEE1dA21bB40B3828Ad3E7CB395d8807d9",
  // Blue-chip collaterals listed alongside WETH, both NON-isolated (shared-risk pool). WBTC is
  // 8-decimal - the frontend reads every reserve's decimals off-chain rather than assuming.
  WBTC:            "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
  S_TOKEN_WBTC:    "0x0000000000000000000000000000000000000000",
  // Recorded even though the frontend enumerates reserves from the chain: scripts resolve
  // external assets through this block (devSeedPairVenue's COLLATERAL=usdc, applyLoopVenues).
  USDC:            "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
  S_TOKEN_USDC:    "0xE93a51e43Fe321cCb263a089F229d9eede62AF66",
  WSTETH:          "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
  S_TOKEN_WSTETH:  "0x0000000000000000000000000000000000000000",
  // wstETH/USD is a COMPOSED feed (stETH/USD x the live Lido rate), deployed by this script rather
  // than a canonical mainnet address - recorded so the checklist and any verifier can find it.
  WSTETH_USD_FEED: "0x0000000000000000000000000000000000000000",
  // USDx's own price feed. Recorded because config/reserves.json references it as $USDX_FEED -
  // a protocol-deployed feed whose address changes every redeploy, so it cannot be pinned there.
  USDX_FEED:       "0xbbc36d8e298BbcbBA4017D4c185491b1b128AB9d",
  WETH_GATEWAY:    "0x21818E27f38441c886a1DA159412F8480dbb38a6",
  // Native-coin deposits into ALM vaults (the vault-side counterpart to WETH_GATEWAY). Per chain,
  // this is the ONLY address that changes; the frontend reads it here and shows the native deposit
  // option on any vault whose pair holds the wrapped-native. See NativeVaultZap.sol.
  NATIVE_VAULT_ZAP: "0x3ec7BdD99cF158F06887Bf61AbfDb64419F6C58e",
  HORIZON_VOTE_ESCROW: "0x31033Af7160bEE7e2f21adC90aD8ec35f9cF218d",
  // Curve-style per-week ve revenue distributor (entry 312). RevenueRouter's staker leg pays it and
  // calls checkpointToken; lockers claim their exact decayed weekly share here, not from the ve
  // (the ve's old Synthetix-style streaming leg was removed in the same redesign).
  HORIZON_REVENUE_DISTRIBUTOR: "0x437ff7344D386Ae73A1b3D45449f773cf284E4A4",
  REVENUE_ROUTER:  "0x08f945f7D416Bfe01961B196d1C5b3d81b6C39c7",
  // BUYBACK now points at the HorizonBuybackArray (the router's re-pointed buyback target). The legacy
  // Buyback.sol is retired from production; its old frontend/indexer surface is reworked in P4.
  BUYBACK:         "0xA405a2D4Ae49dA2978311F2c710b5E48699816Ec",
  HORIZON_BUYBACK_ARRAY: "0xA405a2D4Ae49dA2978311F2c710b5E48699816Ec",
  HORIZON_AUCTION: "0x414a8fac8c2Eec2911b5D22dD6B0D1e0c9fecd6E",
  // Auction input oracle: the mock on a testnet (DEPLOY_MOCK_TITANX), 0x0 on mainnet/fork until launch
  // wires the real one (deployAuctionOracle.cjs). The UI can also read it live via horizonAuction.oracle().
  HORIZON_AUCTION_ORACLE: "0x0000000000000000000000000000000000000000",
  // KeeperIncentives - the HORIZON top-up guaranteeing the keeper gas+premium floor. It is GenesisOwned
  // AND a HORIZON minter, so it MUST be in the book: handoverToSafe is address-book-driven, and while
  // this key was absent the handover silently skipped both its genesis transfer and its minter grant.
  KEEPER_INCENTIVES: "0x86c5a745857B20bf13F32daBe8906a4D6ABfE33f",
  // TitanX ecosystem token addresses the buyback/auction UI reads balances against. Mainnet/fork: the
  // real external tokens. Testnet (DEPLOY_MOCK_TITANX): the public-mint mocks deployed above.
  TITANX:          "0xF19308F923582A6f7c465e5CE7a9Dc1BEC6665B1",
  X28:             "0x5c47902c8C80779CB99235E42C354E53F38C3B0d",
  REFERRAL_REGISTRY: "0x674079c6942E7d4F6ce68c5527D715B096EF6065",
  // Guardian Pools - one SafetyModule proxy per reserve (entry 165), each defending its own debt
  // market. SAFETY_MODULE_<ASSET> keying matches S_TOKEN_<ASSET>'s own convention; the lines are
  // GENERATED from the same catalogue-derived set 8b deployed, so a sixth reserve records its
  // module here without anyone editing this template.
  SAFETY_MODULE_WETH: "0xDF0aDe0eC49f913746732E945c989eAaC40e894c",
  SAFETY_MODULE_USDC: "0xCF44d533A7766Ba299579eA0262fa61c0da81bA3",
  // First-loss cover pool (Feature 5, entry 214) - per COVER ASSET, not per reserve; underwrites
  // coverage lines for future protected products. Backend primitive only for now, no frontend
  // surface until the first senior product ships (Phase C, post-audit).
  FIRST_LOSS_VAULT_USDX: "0x0000000000000000000000000000000000000000",
  // Integration surfaces - immutable, stateless, no protocol authority. POOL_VIEWS is the
  // Aave-shaped read surface liquidation bots build against; WRAPPED_SUSDX is the ERC-4626
  // adapter yield aggregators discover by scanning for the standard.
  POOL_VIEWS:      "0xE57386c6f8d51F3C53F4790a716537bbB60d5562",
  WRAPPED_SUSDX:   "0x0000000000000000000000000000000000000000",
  // D1 (entry 208): the rest of the supply side's 4626 doorways + the vaults' lens, both
  // catalogue-derived - generated lines, like the guardian modules above.
  WRAPPED_SWETH: "0xf99d03dAa0ADb1767F382190b7c14d1629c3c6cA",
  WRAPPED_SUSDC: "0x405c38a4939FCe0bCe49e21c717c8c093d95618B",
  VAULT_LENS:      "0x4BC19A536178cf7E8EE49206357f68c891752FA0",
  // Leveraged looping, periphery only - holds no user funds between transactions and has no
  // pool privilege; each user delegates to it themselves.
  MULTIPLY_ROUTER: "0x434541d6aA0e8395d30e6E6Dd0A83680bc8Cd4B7",
  // Canonical Permit2 singleton (same address every chain; MockPermit2 etched here on local). The
  // frontend signs SignatureTransfer permits against it for one-tap supply/repay/stake/lock/open.
  PERMIT2:         "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  // Trustless periphery router giving the ALM vaults a Permit2 one-tap deposit (the vaults are at
  // the code-size limit, so this lives outside them). See VaultZapPermit.sol.
  VAULT_ZAP_PERMIT: "0x346cb8F9081CA561946E5F0f258e64dB7C075465",
  // Opt-in liquidation protection. Periphery, immutable, and it moves a user's collateral ONLY
  // while that user's own health factor sits below the trigger they set - so the app must read
  // per-user settings off it rather than assume anything protocol-wide.
  PROTECTION_MANAGER: "0xD87017b506909Ac87873E40Bd2737A89CC5845bf",
  // Vault system - shared infrastructure only (see step 10's own doc comment); no vault instance
  // is created by this script, so there is no VAULT_/individual-vault address to record here.
  POOL_MANAGER:       "0x000000000004444c5dc75cB358380D2e3dE08A90",
  VAULT_ORACLE_HOOK:  "0xaE173881FBe91b097eD72944B0c95f1A5200b080",
  VAULT_BEACON_V3:    "0x01e39142002dA55f52c098A910D68534F13F8ADa",
  VAULT_BEACON_V4:    "0x12E1ACE4Bb50ad096B0447524a7dF4f0fdDbAB2D",
  REBALANCE_GUARD:    "0xbe613AA10f731EA38786a082A341fe1A1BC9e266",
  VAULT_FEE_MANAGER:  "0x6EAE2C1499f7372414AA3AaAEa4dCa6895fe73bF",
  CLEARING_V3:        "0x9Eba37c7C933Ee90E49E6163D5Dc80679E7fF2f3",
  CLEARING_V4:        "0x4C5A7f7ba4758036aDD753A128bF2206F86BB3BC",
  VAULT_FACTORY:      "0xc1C78ed758474757090b876d08Af6d1286F7facb",
  // ve(3,3) voting layer (entry 296-298): the weekly-reset gauge and the fees-follow-votes
  // distributor. Deployed dormant - fees-follow-votes activates via a genesis sequence once vaults
  // are created and votes cast (see deployLocal's own ACTIVATE ve(3,3) print).
  GAUGE_CONTROLLER:   "0xC959f5aEe6FC8442638D1DFF7481c5aDBfc29a77",
  FEE_DISTRIBUTOR:    "0x053f917e6b58083Ff8932579B07424D7D5daEa27",
  BRIBE_MARKET:       "0x56E71fcC37e573cD3291c0906053e51E5c83518c",
  // Single-asset staking registry. The app enumerates this rather than carrying a hardcoded list,
  // so listing an asset is a genesis transaction and needs no frontend deploy. Deployed here (step
  // 10b) precisely so it survives a redeploy - it used to be created only by
  // scripts/createStakingVault.cjs and had to be pasted back in by hand every time.
  STAKING_VAULT_FACTORY: "0xC19B5E94C357aB105161e15A7B95eCCE37405401",
  // Deploy block of HorizonLendingPool - the Liquidations page's event-log scan (useAllBorrowers)
  // starts from here, not block 0, since a mainnet-fork chain inherits the real chain's full
  // height and forked RPC providers commonly cap eth_getLogs to a bounded block range (e.g.
  // 50,000 blocks) - scanning from literal genesis fails outright on a fork.
  LENDING_POOL_DEPLOY_BLOCK: "25840427",
};
